export default "__VITE_ASSET__zIpQK4Iv__"